import React, { useMemo, useCallback, useEffect, useState } from 'react'
import style from "./index.module.scss"
import { useMappedState, useDispatch } from 'redux-react-hook'
import { GoodsType } from 'types/interface'
import Icon from 'components/Icon/Icon'
import { createAction, SET_CURGOODS, SET_COUPON, IS_DEFAULT_COUPON } from 'store/ActionTypes'
import classNames from 'classnames'
import { qsFromResultUrl, isMobile } from 'utils/dom'
import { Link } from 'react-router-dom'
import { PayTypeEnum } from 'types/enum'
import specialHeadImg from "assets/img/png/pic_card_bg@2x.png"
import { RouterPaths } from 'utils/constant'
import { payTypeToCurrencySymbol, trim, resetVerify, checkCaptcha, getCaptcha } from 'utils/utils' 
import Inp from '../../components/input/RechargeInput'
import Modal from '../../components/model/newModal'
import useCDKey from "../../hooks/useCDKey"
import { $cardmiExchange, $couponSearch, $getLink } from './exchangeCardmi'
// import { handleCaptchaCode } from "utils/verify"
import { useHistory } from 'react-router-dom'
import { $userInfo } from "../../service/sign"
import { Input } from "antd"
import { Btn } from "../menu/components/tabsContent"
import Edit from 'assets/img/png/chckout_icon_edit@2xgreen.png'
import CouponImg from 'assets/img/png/icon_coupon.png'
import { clearLoginInfo } from 'service/sign'
import ModelFn from 'components/model/ModelFn'
import Verify from "../../components/verify/index"

function RechargeList({ select, setselect, sethints, setComplete, setuseCode, sethideusecode, checkoutCoupon, setcheckoutCoupon }) {
  // const [select, setselect] = useState(false)
  const [hint, setHint] = useState(undefined)
  const [show, setshow] = useState(false)
  const [loading, setloading] = useState(false)
  const [val, setval] = useState('') 
  const [IsFocus, setIsFocus] = useState(false)
  const [service_days, setservice_days] = useState(0)
  const [reset, setreset] = useState(false)

  const history = useHistory()

  //重置验证组件
  const resetComponent=()=>{
    resetVerify(setreset)
  }

  const $request = useCallback(() => {    
    if (trim(val).length < 10) {
      return {
        status: 'error',
        error: '请输入正确的卡密'
      }
    } else {
      if (checkCaptcha()) {
        return {
          status: 'error',
          error: 'validate fail'
        }
      }
      return $cardmiExchange(
        trim(val),
        getCaptcha()
      )
    } 
  }, [val])
  const successFn = async () => {
    await $userInfo()
    // setisYunPian(false)
    // initYpRiddler()
    // clearVerify()
    window['captcha']=''
    setHint('')
    setshow(true)
  }
  const onCancel = () => {
    setshow(false)
  }

  const clickOk = useCDKey({ loading, setloading, $request, setHint, successFn, setIsFocus, setservice_days,resetComponent })
  // const clickOk=()=>{
  //   console.log(val)
  //   console.log(trim(val))



  // }

  const onConfirm = () => {
    history.push('/')
    $userInfo()
  }
  const clickCardmi = () => {
    setselect(true)
    // if (isYunPian) {
    //   setTimeout(() => initYpRiddler(), 0)
    // }

  }


  return (
    <div className={style['recharge-list']}>
      <div className={style.rechargePackage}>
        <div className={style.title}>
          会员充值 <span>官网充值更优惠</span>
        </div>
        <SurplusTime />
      </div>
      <div className={style.tabs}>
        <div onClick={() => setselect(false)} style={{ color: select ? '#1ac89d' : 'white' }} >
          套餐充值
        </div>
        <div onClick={() => clickCardmi()} style={{ color: select ? 'white' : '#1ac89d' }} >
          卡密充值
        </div>
        <div onClick={() => setselect(true)} className={style.choose} style={{ transform: select ? `translateX(${document.body.clientWidth > 767 ? '.7rem' : '64px'})` : `translateX(${document.body.clientWidth > 767 ? '-.7rem' : '-64px'})`, transition: 'all 0.4s ease-out 0s' }} />
      </div>
      <Modal
        show={show}
        onConfirm={onConfirm}
        onCancel={onCancel}
        title={'卡密充值成功'}
        text={<div className={style.cardmiModal}>
          <div>已为 <span>{localStorage.UserInfo && JSON.parse(localStorage.UserInfo).phone_num}</span> 充值了 <span>{service_days}</span> 天</div>
          <div>当前账户到期时间 {localStorage.UserInfo && JSON.parse(localStorage.UserInfo).expire_at}</div>
        </div>}
      />

      {select ?
        <div className={style.RechargeExchange}>
          <div className={style.head}>
            请输入您的卡密，兑换会员时长
          </div>
          <div className={style.RechargeCDKey}>
            <Inp placeholder='xxxxx-xxxxx-xxxxx-xxxxx' hint={hint} val={val} setval={setval} setIsFocus={setIsFocus} IsFocus={IsFocus} />
            {/* {captcha && <div className={style.captcha}>
              <div id={isYunPian ? "cbox" : "captcha"} /> 
            </div>} */} 
            <Verify reset={reset} style={{marginBottom:'0rem',display:'flex',height:'auto',marginTop:20}} />  
            <div className={style.ok} onClick={() => clickOk()} >
              {loading && <Icon icon="iconloading" className={style.loading} />}
              充值
            </div>
          </div>
          <div className={style.foot}>
            <div style={{ marginBottom:0 }}>• 参加“<a style={{color:'#41BDA7'}} href='/payment/activity'>穿梭推广活动</a>”，免费获取兑换卡密。</div>
            <div>
              • 卡密会在兑换时自动转化成对应的会员时长，具体天数取决于卡密的面值。
            </div>
            <div>
              • 一旦兑换完成，您将不得撤销或要求将卡密回兑成相应的现金。
            </div>
            <div>
              • 兑换后请在穿梭客户端进行一次连接，即可更新会员时长。
            </div>
          </div>
        </div>
        : <div className={style['card-list']}>
          <RechargeCards setcheckoutCoupon={setcheckoutCoupon} sethints={sethints} setComplete={setComplete} setuseCode={setuseCode} sethideusecode={sethideusecode} />
        </div>}
    </div>
  )
}

const SurplusTime = React.memo(() => {
  const [userInfo, logined] = useMappedState(state => [
    state.user.userInfo,
    state.user.logined
  ])
  const ms = useMemo(() =>
    +(userInfo.expire_at_time * 1000 - Date.now())
  , [userInfo.expire_at_time])
  let days = 0

  if (ms > 0) {
    days = Math.floor(ms / 1000 / 60 / 60 / 24)
  }

  if (!logined) {
    return (
      <div className={style.time}>
        <div className={style['time-item']}>
          <span className={style['time-title']}>
            您当前未登录，登录账号后即可购买。
          </span>
          <Link to={ isMobile() ? RouterPaths["signin-phone"] : RouterPaths["signin-qr"] } className={style['time-time']}>
            立即登录
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className={style.time}>
      <div className={style['time-item'] + ' ' + style['time-item2']}>
        <span className={style['time-title']}>账号信息：</span>
        <span className={style['time-info']}>
          {`${userInfo.email} 穿梭ID:${userInfo.transocks_id}`}
        </span>
      </div>
      <div className={style['time-item']}>
        <span className={style['time-title']}>当前账户时长：</span>
        <span className={style['time-time']}>
          {`剩余`}<span className={style['time-days']}>{days}</span>{`天（${userInfo.expire_at}到期） `}
        </span>
      </div>
    </div>
  )
})

interface RechargeCardsProps {
  sethints?: any;
  setComplete?: any;
  setuseCode?: any;
  sethideusecode?: any;
  setcheckoutCoupon?: any;
}

const RechargeCards = React.memo(({ sethints, setComplete, setuseCode, sethideusecode, setcheckoutCoupon }: RechargeCardsProps) => {

  const [$goods, curGood] = useMappedState(state => [
    state.recharge.goods,
    state.recharge.curGoods,
    state.recharge.payType
  ])
  // console.log(curGood,'1111')

  const search = useMemo(qsFromResultUrl, [])
  const dispatch = useDispatch()

  const goods = useMemo(() => {
    const arr = $goods ? $goods : []
    return arr.map(g => {
      const oneDayPrice = (g.present_price / g.service_days).toFixed(2)
      const oneDayUsdPrice = (g.present_usd_price / g.service_days).toFixed(2)
      const oneDayHKDPrice = (g.present_hkd_price / g.service_days).toFixed(2)
      const discount = `${Math.ceil((1 - (g.present_price / g.regular_price)) * 100)}%`
      const usdDiscount = `${Math.ceil((1 - (g.present_usd_price / g.regular_usd_price)) * 100)}%`
      const hkdDiscount = `${Math.ceil((1 - (g.present_hkd_price / g.regular_hkd_price)) * 100)}%`
      return Object.assign({}, g, {
        oneDayPrice,
        oneDayUsdPrice,
        oneDayHKDPrice,
        usdDiscount,
        hkdDiscount,
        discount
      })
    })
  }, [$goods])

  const switchCurDays = useCallback((data: GoodsType) => {
    
    dispatch(createAction(SET_CURGOODS, data))
    setComplete(false)
    sethints(null)
    sethideusecode(true)
    setcheckoutCoupon(true)
    dispatch(createAction(SET_COUPON, {}))
    if (localStorage.links) {
      if (JSON.parse(localStorage.links).url) {
        if (JSON.parse(localStorage.links).url.default_discount_code) {
          if (!JSON.parse(localStorage.links).url.default_discount_code.split('_')[0]) {
            setuseCode(false)
          }
        }
      }

    }
    // if (localStorage.UserInfo) {

    //   dispatch(createAction(SET_CURGOODS, data))
    //   // setuseCode(false)
    //   setComplete(false)
    //   sethints(null)
    //   sethideusecode(true)
    //   setcheckoutCoupon(true)
    //   dispatch(createAction(SET_COUPON, {}))
    //   if (localStorage.links) {
    //     if (JSON.parse(localStorage.links).url) {
    //       if (JSON.parse(localStorage.links).url.default_discount_code) {
    //         if (!JSON.parse(localStorage.links).url.default_discount_code.split('_')[0]) {
    //           setuseCode(false)
    //         }
    //       }
    //     }

    //   }
    // } else {
    //   dispatch(createAction(SET_CURGOODS, data))
    //   setComplete(false)
    //   sethints(null)
    //   sethideusecode(true)
    //   if (localStorage.links) {
    //     if (JSON.parse(localStorage.links).url.default_discount_code) {
    //       if (!JSON.parse(localStorage.links).url.default_discount_code.split('_')[0]) {
    //         setuseCode(false)
    //       }
    //     }

    //   }

    // }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, setComplete, sethints, sethideusecode, setuseCode, setcheckoutCoupon])

  // 页面刷新时选择默认商品
  useEffect(() => {
    if (!search.status) {
      const good = Object.assign({}, goods[0])
      switchCurDays(good)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [goods])

  return (
    <div className={style['card-list-content']}>
      {
        goods.map(item => (
          <RechargeCard
            key={item.id}
            goods={item}
            actived={item.service_days === curGood.service_days}
            switchCurDays={() => switchCurDays(item)}
          />
        ))
      }
      {/* <div className={style.coupon}>
        <img src={plus} alt="" />
        使用折扣码?
      </div> */}
      {/* <UseCoupon goodsId={curGood.id} setuseCode={setuseCode} useCode={useCode} setComplete={setComplete} Complete={Complete} sethint={sethint} hint={hint} /> */}
    </div>
  )
})

interface RechargeCardProps {
  goods: any,
  actived: boolean,
  switchCurDays: () => any
}

const RechargeCard = React.memo(({ switchCurDays, goods: good, actived }: RechargeCardProps) => {
  const [payType] = useMappedState(state => [state.recharge.payType])

  const cardClass = classNames(style.card, {
    [style[`card-active`]]: actived,
    [style[`special-card-active`]]: (actived && good.special_offer)
  })

  const prevent = useCallback((e: any) => {
    // 判断默认行为是否可以被禁用
    if (e.cancelable) {
      e.preventDefault()
    }
    e.stopPropagation()
  }, [])

  const handleSwitchCurDays = useCallback((e: any) => {
    if (isMobile() && e.type === 'click') {
      return
    }
    prevent(e)
    // console.log('切换e',e)

    switchCurDays()
  }, [prevent, switchCurDays])

  const data = (() => {
    const d = {
      oneDayPrice: good.oneDayPrice,
      discount: good.discount,
      present_price: good.present_price,
      regular_price: good.regular_price
    }
    if (payType === PayTypeEnum.paypal) {
      d.oneDayPrice = good.oneDayUsdPrice
      d.discount = good.usdDiscount
      d.present_price = good.present_usd_price
      d.regular_price = good.regular_usd_price
    }
    if (payType === PayTypeEnum.alipay_qr_intl) {
      d.oneDayPrice = good.oneDayHKDPrice
      d.discount = good.hkdDiscount
      d.present_price = good.present_hkd_price
      d.regular_price = good.regular_hkd_price
    }
    return d
  })()

  const showUnit = payTypeToCurrencySymbol(payType)

  return (
    <div
      onTouchEnd={handleSwitchCurDays}
      onClick={handleSwitchCurDays}
      className={cardClass}>
      <div className={style.head}>
        {
          good.special_offer
            ? <img className={style['special-head']} src={specialHeadImg} alt="" />
            : <span className={style['card-title']}>{`${good.service_days}天VIP`}</span>
        }
      </div>
      <div className={style.body}>
        <div className={style.price}>
          {
            good.special_offer
              ?
              <span className={style.num + ' ' + style['special-price']}>
                <span className={style.symbol}>{showUnit}</span>
                {data.present_price}
                <span className={style.unit}>/{good.service_days}天</span>
              </span>
              : (
                <div>
                  <span className={style.num}>
                    <span className={style.symbol}>{showUnit}</span>
                    {data.oneDayPrice}
                  </span>
                  <span className={style.unit}>/天</span>
                </div>
              )
          }
        </div>
        {
          good.special_offer
            ? <div className={style['special-desc']}>
              <div>{good.special_offer_desc}</div>
              <div>每个账号限购一次</div>
            </div>
            : (
              <div className={style.comparison}>
                <div>
                  <span>官网售价</span>
                  <span>{showUnit + data.present_price}</span>
                </div>
                <div>
                  <span>App端售价</span>
                  <span>{showUnit + data.regular_price}</span>
                </div>
              </div>
            )
        }
      </div>
    </div>
  )
})

// const Recharge

export const UseCoupon = ({ goodsId, useCode, setuseCode, Complete, setComplete, sethint, hint, ismodify, setismodify, setval, val, setcheckoutCoupon, checkoutCoupon }) => {
  // const [val, setval] = useState('')
  // const [checkoutCoupon, setcheckoutCoupon] = useState(true)
  const [tips, settips] = useState('*双11特惠折扣券，仅限11-12日。')
  // const [ismodify, setismodify] = useState(false)
  // const [hint, sethint] = useState(null)

  const dispatch = useDispatch()
  // const [Complete, setComplete] = useState(false)
  // const [useCode, setuseCode] = useState(false)
  const [loading, setloading] = useState(false)
  const [cancel, setcancel] = useState(false)



  const clickCoupon = () => {

  }

  //使用折扣码
  const UseCouponCode = async (value?) => {
    const coupon_code = value == null ? val : value
    setloading(true)
    const res = await $couponSearch(coupon_code, goodsId)
    if(JSON.parse(localStorage.links).url.default_discount_code.split('_')[0]){
      dispatch(createAction(IS_DEFAULT_COUPON, true))
      setismodify(false)
    }
    if (res.status === 'ok') {
      setComplete(true)
      dispatch(createAction(SET_COUPON, res.data))
      if (res.data.comment) { settips(res.data.comment) }
      sethint(null)
    }else if(JSON.parse(localStorage.links).url.default_discount_code.split('_')[0] && res.code === 30009){
      setismodify(true)
      setcancel(true)
      dispatch(createAction(IS_DEFAULT_COUPON, false))
      dispatch(createAction(SET_COUPON, {}))
      setuseCode(false)
      setval('')
      settips('')
    } else {
      console.log(res.error)
      dispatch(createAction(SET_COUPON, {}))
      if (res.error === 'This is not a valid code, please retype.' || res.error === 'This Coupon code invalid.') {
        sethint('此折扣券无效')
      } else if (res.error === 'Unknown Plan') {
        sethint('此折扣码不能用于该商品')
      } else if (res.error === 'You have already used this coupon code.') {
        sethint('此折扣码只能使用一次')
      } else if (res.error === 'This Coupon code has expired.') {
        sethint('折扣码已过期')
      } else if (res.error === 'CouponCode is a required field') {
        sethint('折扣码不能为空')
      } else if (res.error === 'Require login') {
        sethint('请先登录')
      } else {
        sethint(res.error)
      }
    }
    setloading(false)
  }
  //处理数据
  const handleData = async () => {
    //商品id为空时不做处理
    if (!goodsId || cancel) { return }
    let Link = localStorage.links
    if (!Link || !JSON.parse(Link).url || !JSON.parse(Link).url.default_discount_code) {
      const res = await $getLink()
      localStorage.setItem('links',JSON.stringify(res))
      Link = JSON.stringify(res)
    }
    if (!JSON.parse(Link).url.default_discount_code.split('_')[0]) {
      settips('')
      sethint('')
      // setval('')
      setComplete(false)
      setismodify(true)
    }
    
    if((val === JSON.parse(Link).url.default_discount_code.split('_')[0] || val === '' ) && JSON.parse(Link).url.default_discount_code.split('_')[0]){
      setval(JSON.parse(localStorage.links).url.default_discount_code.split('_')[0])
      settips(JSON.parse(localStorage.links).url.default_discount_code.split('_')[2])
      UseCouponCode(JSON.parse(Link).url.default_discount_code.split('_')[0])
    }
    // if(JSON.parse(Link).url){
    // if (localStorage.UserInfo) {
    //   if ((val === JSON.parse(Link).url.default_discount_code.split('_')[0] || val === '') && !ismodify) {
    //     if (JSON.parse(Link).url.default_discount_code.split('_')[0]) {
    //       setval(JSON.parse(Link).url.default_discount_code.split('_')[0])
    //       setTimeout(() => { UseCouponCode(JSON.parse(Link).url.default_discount_code.split('_')[0]) }, 100)
    //     }
    //   }

    // } else {
    //   if (JSON.parse(Link).url.default_discount_code.split('_')[0]) {
    //     setval(JSON.parse(Link).url.default_discount_code.split('_')[0])
    //     settips(JSON.parse(Link).url.default_discount_code.split('_')[2])
    //   }

    // }
    // }

  }
  useEffect(() => {
    $getLink()
  }, [])

  useEffect(() => {
    !loading && handleData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [goodsId])




  //inputchange事件
  const inpChange = (e) => {
    setval(e.target.value)
  }
  const edit = () => {
    !checkoutCoupon && setcheckoutCoupon(true)
    setComplete(false)
    settips('')
    sethint('')
    setismodify(true)
  }
  const clearInput = () => {
    sethint('')
    setval('')

  }
  const clickUseCode = () => {
    if (localStorage.UserInfo) {
      setuseCode(true)
    } else {
      clearLoginInfo()
      ModelFn.confirm({
        text: "请先登录穿梭账号",
        onConfirm: () => { isMobile() ? window.location.replace(RouterPaths["signin-phone"]) : window.location.replace(RouterPaths["signin-qr"]) },
        noCancel: true
      })
    }


  }

  //选中优惠券
  const checkCoupon = () => {
    // UseCouponCode('')
    // if (!localStorage.UserInfo) return
    setcheckoutCoupon(!checkoutCoupon)
    if (checkoutCoupon) {
      UseCouponCode('')
    } else {
      UseCouponCode(val)
    }
    // console.log(setcheckoutCoupon,checkoutCoupon)

  }

  return <div className={style.coupon} onChange={inpChange} onClick={() => clickCoupon()}>
    {/* <div className={hint ? style.img3 : Complete ? style.img2 : style.img} /> */}
    {
      //显示--使用折扣码按钮--输入框
      useCode ?
        ((!Complete) ? (hint ? <><div className={style.errorCou}><div className={style.errorInp}>
          <div className={style.close} onClick={() => clearInput()}></div>
          <div>
            {val}
          </div>
        </div>
        <Btn classnames='couponCode' content='确定' click={() => { }} />
        </div>
          <div className={style.hint}>{hint}</div>
        </>
          : <div className={style.putCoupon}>
            <div className={style.input}>
              <Input value={val} id="couponInp" className={style.couponInp} placeholder='输入折扣码' />
              <Btn classnames='couponCode' content='确定' click={() => UseCouponCode()} />
            </div>
            {/* {hint && <div className={style.hint}>{hint}</div>} */}
          </div>)
          : <div className={style.defaultComplete}>
            <div className={style.InputLine}>
              <div className={checkoutCoupon ? style.couponComplete : style.couponClose}>
                <div onClick={checkCoupon} className={style.statusCheck}></div>
                <div>
                  {val}
                </div>
                <img src={Edit} alt="" onClick={() => edit()} />
              </div>
              {/* <div className={style.btn}> 确定
              </div> */}
            </div>

            {((localStorage.links && !localStorage.UserInfo) || tips) && <div className={style.tips}>
              {tips}
            </div>}
          </div>
        )
        : <div className={style.useCode} onClick={() => clickUseCode()}>
          <img src={CouponImg} alt="" />
          <div>
            使用折扣码?
          </div>
        </div>
    }


  </div>
}


export default React.memo(RechargeList)
